import { HomeComponentProps, HomeComponentState, HomeComponentHandler } from './homecomponent';
import { HomeCSSStyle } from './homecss';
import { UIComponentHandler } from '../../../toolkit/uicomponent';
import * as React from 'react';
import { FeaturedCategoryDto } from '../../../../core/dto/featuredcategory/featuredcategorydto';
import { BaseContext } from '../../../../utils/basecontext';
import { CRBTUIViewImpl } from '../crbt/crbtuiview';
import { BannerComponent } from '../banner/bannercomponent';
import { BannerDto } from '../../../../core/dto/banner/bannerdto';
import { Strings } from '../../../../utils/resources/strings';
import { FeaturedCategoryComponent } from '../featuredcategory/featuredcomponent';
// import { SearchBoxComponent } from '../../../toolkit/toolbarwithsearch/searchbox/searchboxcomponent';
// import { SearchBoxCSSStyle, SearchBoxCSSStyleImpl } from '../../../toolkit/toolbarwithsearch/searchbox/searchboxcss';
import { SearchBoxToneOptionComponent } from '../../../toolkit/toolbarwithsearch/searchbox/searchboxtoneoption/searchboxtoneoptioncomponent';
import './home-style.css';
// import '../crbt/crbt-style.css';
import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class HomeViewImpl extends CRBTUIViewImpl
{ 
    // private searchCSSStyle:SearchBoxCSSStyle;
    // private featuredCategroiesRefMap: Map<string, FeaturedCategoryListComponent>;
    constructor(context: BaseContext, uiComponentHandler: UIComponentHandler)
    {
        super(context, uiComponentHandler);

        // this.searchCSSStyle = new SearchBoxCSSStyleImpl(context);
        // this.featuredCategroiesRefMap = new Map();
    }

    bindHandlers()
    {
        this.onBannerClick = this.onBannerClick.bind(this);
        // this.onCategorySelected = this.onCategorySelected.bind(this);
        this.onLoadMore = this.onLoadMore.bind(this);
        this.onSearchButtonClick = this.onSearchButtonClick.bind(this);
        this.onSpecificSearchClick = this.onSpecificSearchClick.bind(this);
    }

    draw(props: HomeComponentProps, state: HomeComponentState, cssStyle: HomeCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <>
            
                <div id="home-wrapper">
                    {
                        this.getWebView(props, state, cssStyle)
                    }
                </div>
                
            </>);
    }

    getWebView(props: HomeComponentProps, state: HomeComponentState, cssStyle: HomeCSSStyle):JSX.Element
    {
        return(
            <>
                    
                       {
                           state.isConfiguartionLoaded && state.listOfBannerDtos.length > 0 && 
                            <BannerComponent onBannerClick={this.onBannerClick} listOfBannerDto={state.listOfBannerDtos} context={props.context}/>
                       }
                       <div id="home-search-main" style={{backgroundColor:this.getContext().getResources().getColor(Colors.color_3)}}>
                       <div id="home-search-div" style={{}}>
   
                               <SearchBoxToneOptionComponent type={props.context.getResources().getString(Strings.song)} context={this.getContext()} searchKey={""} onSearchBoxButtonClicked={this.onSpecificSearchClick}/>
                           </div>
                      </div>    
                      {state.isConfiguartionLoaded && 
                       <div id="home-inner-wrapper" style={cssStyle.getInnerCSSStyle()}>
                            <FeaturedCategoryComponent context={props.context}/>
                       </div>
                      }
                      
                       {<>
                            <div id="home-nametune-web">
                                {
                                    this.getWebNameTune(state,props,cssStyle)
                                }
                            </div>
                            <div id="home-nametune-mobile">
                                {
                                    this.getMobileNameTune(state,props)
                                }
                            </div>
                       </>}
                       
            </>
        );
    }

    getMobileNameTune(state:HomeComponentState,props:HomeComponentProps):JSX.Element
    {
        return(
            <>
                  {/* <div id={"home-nametune-english"} style={{width:'100%', height:'177px',justifyContent:"center", marginTop:'0px',display: "flex", flexFlow: "row wrap",backgroundColor:this.getContext().getResources().getColor(Colors.color_3),backgroundSize: "cover",}}>
                           
                           <label style={{width:'100%',fontWeight:900, paddingLeft:'15%',paddingRight:'15%',fontFamily:this.getContext().getResources().getFontFamily(),paddingTop:'40px', height:'48px', lineHeight:'24px',fontSize:'20px',color:this.getContext().getResources().getColor(Colors.color_6),textAlign:'center'}}>
                               {this.getContext().getResources().getString(Strings.greet_caller_with_your_name_tunes)}
                           </label>
                           <div style={{marginTop:'9px',width:'100%',height:'40px',marginLeft:'5%', paddingBottom: '30px',marginRight:'5%',}}>
                               <SearchBoxComponent  cssStyle={this.searchCSSStyle} searchKey={''} onSearchBoxButtonClicked={this.onSearchButtonClick} context={props.context}/>
                           </div>
                       </div> */} 
                 
                <div style={{display:"inline"}}>
                {this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? <img style={{height:"auto",width:"100%",display:"flex",flexFlow:"row wrap"}} src={this.getUIProps().context.getResources().getImage("express_yourself_mobile.svg")} />
                       :<img style={{height:"auto",width:"100%",display:"flex",flexFlow:"row wrap"}} src={this.getUIProps().context.getResources().getImage("express_yourself_french_mobile.svg")} />}
                      
                </div>           
                         

                          
            </>
        );
    }
    getWebNameTune(state:HomeComponentState,props:HomeComponentProps,cssStyle:HomeCSSStyle):JSX.Element{
        return(
            <>
                <div style={cssStyle.getNameTuneMainDivCSSStyle()}>

        
                  {/* <div  style={cssStyle.getNameTuneDivCSSStyle()}>
                           <label  style={cssStyle.getNameTuneLabelCSSStyle()}>
                               {this.getContext().getResources().getString(Strings.greet_caller_with_your_name_tunes)}
                           </label>
                           <div id="search-box-main-div" style={cssStyle.getNameTuneSearchDivCSSStyle()}>
                               <SearchBoxComponent  cssStyle={this.searchCSSStyle} searchKey={''} onSearchBoxButtonClicked={this.onSearchButtonClick} context={props.context}/>
                           </div>
                       </div>   */}  
               
                    <div style={{display:"inline"}}>
                    {this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?
                    <img style={{height:"auto",width:"100%",display:"flex",flexFlow:"row wrap"}} src={this.getUIProps().context.getResources().getImage("express_yourself_web.svg")} />
                     :<img style={{height:"auto",width:"100%",display:"flex",flexFlow:"row wrap"}} src={this.getUIProps().context.getResources().getImage("express_yourself_french_web.svg")} />
                    } 
                    </div>       
                </div>   
                
            </>
        );
    }
    

    onSpecificSearchClick(searchKey:string, type:string):void
    {
        searchKey = searchKey.trim();
        (this.getUIComponentHandler() as HomeComponentHandler).onSpecificSearchClick(searchKey,type);

    }
    onSearchButtonClick(searchKey: string):void
    {
        searchKey = searchKey.trim();
        (this.getUIComponentHandler() as HomeComponentHandler).onSearchClick(searchKey);
    }
   getNavigationPath(): string[]
   {
       return [this.getUIProps().context.getResources().getString(Strings.home)];
   }


    private onBannerClick(bannerDto: BannerDto)
    {
        (this.getUIProps() as HomeComponentProps).onBannerClick(bannerDto);
    }

    private onLoadMore(featuredCategory: FeaturedCategoryDto, startIndex: number, offset: number): void
    {
        (this.getUIComponentHandler() as HomeComponentHandler)
                               .loadMoreFeaturedCategoryTones(featuredCategory, startIndex, offset);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/home/homeview.tsx